export const vertexShader = `
    varying vec2 v_uv;
    varying vec3 v_position;
    varying vec3 v_normal;
    varying vec3 v_worldPosition;
    void main() {	
        v_uv = uv;
        v_position = position;
        v_worldPosition = (modelMatrix * vec4(position, 1.0)).xyz;
        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
    }
`;
export const fragmentPlane = `
    #define PI 3.141592653589
    varying vec2 v_uv;
    uniform vec3 u_light;
    varying vec3 v_position;
    varying vec3 v_worldPosition;
    varying vec3 v_normal;
    uniform sampler2D u_text;

    float getScatter(vec3 cameraPos,vec3 dir,vec3 lightPos, float d){
        vec3 q = cameraPos - lightPos;
        float b = dot(dir, q);
        float c = dot(q, q);
        float t = c - b*b;
        float s = 1.0 / sqrt(max(0.0001, t));
        float l = s * (atan ( (d+b) * s) - atan (b*s));
        return pow(max(0.0, l / 150.), 0.8 );
    }
    void main()	{
        vec3 cameraToWorld = v_worldPosition - cameraPosition;
        vec3 cameraToWorldDirection = normalize(cameraToWorld);
        float cameraToWorldDistance = length(cameraToWorld);
        vec3 lightToWorld = normalize(u_light - v_worldPosition);
        float diffusion = max(0., dot(v_normal, lightToWorld));
        float dist = length(u_light - v_position);
        
        float scatter = getScatter(cameraPosition, cameraToWorldDirection, u_light, cameraToWorldDistance);        
        gl_FragColor = vec4(0.932 + scatter,0.909 + scatter,0.458 + scatter,1.0);
    }
`;